export const calculateDeadline = () => {
  const deadline = BigInt(
    Math.floor(new Date(new Date().getTime() + 60 * 60 * 1000).getTime() / 1000)
  )
  return deadline
}
